import React from 'react'
import { classNames } from '../_utils'

import { at } from 'lodash'
import { useField } from 'formik'

export default function SelectFieldIcon( {disabled = false, required = false, nopadding = false, question,name, iconComponent, label, handleChange, handleBlur, value, options } ) {
  
  const [ field, meta ] = useField( name )

  const _renderText = () => {
    const [ touched, error ] = at( meta, 'touched', 'error' ) 
    if( touched && error )
      return error
  }

  return (
    <div className="py-1 w-full flex flex-col">
      <p className="text-gray-700 text-xs">
        {question}{ required && ( <span className="text-red-500 font-bold">*</span>) } 
      </p>
      <div className={classNames( ( meta.touched && meta.error ) ? "inline-flex w-full rounded-sm border border-red-500 h-7 my-1 mb-3 relative" : "inline-flex w-full rounded-sm h-8 my-1 mb-3 relative" ) } >
        <select 
          disabled={disabled}
          name={name}
          id={name}
          className={ classNames( (  meta.touched && meta.error ) ? "w-full px-2 py-0 focus:outline-none focus:text-gray-600 placeholder-red-500 text-black text-sm" : "w-full px-2 py-0 focus:outline-none focus:text-gray-600 placeholder-black text-black text-sm") } 
          required={required}
          placeholder={label}
          onChange={handleChange}
          onBlur={handleBlur}
          value={value}>
            <option className="text-gray-500" value="">Choose...</option>
            {options?.map( item => {
              return (
                <option key={item.id}  className="text-black" value={item.value}>
                  {item.label}
                </option>
              ) } )}
        </select>

        {(meta.touched && meta.error) ? (
          <p className="absolute -bottom-6 left-0 text-red-500 py-1 text-sm">
            {_renderText()}
          </p>
          ) : (
          <p className="absolute -bottom-6 left-0 text-gray-700 py-0 text-sm">
            {/* {question}{ required && ( <span className="text-red-500">*</span>) } */}
          </p>
        ) }

      </div>
    </div>
  )
}
